class ArticleCards extends HTMLElement {
  constructor() {
    super();
    this.blogHandle = this.getAttribute('blog-handle');
    this.paginateNumber = parseInt(this.getAttribute('paginate-number'));
    this.columnSizeTablet = parseInt(this.getAttribute('column-size-tablet'));
    this.columnSizeDesktop = parseInt(this.getAttribute('column-size-desktop'));
    this.blogPosts = [];
    this.selectedTags = [];
    this.paginationData = { nextUrl: null, totalItems: 0 };
    this.attachShadow({ mode: 'open' });

  }

  connectedCallback() {
    this.fetchBlogPosts();
  }

  async fetchBlogPosts() {
    const query = `
      query {
        articles(first: 250, query: "tag:vaara-world", sortKey:PUBLISHED_AT) {
          edges {
            node {
              id
              handle
              title
              content
              tags
              excerptHtml
              image {
                id
                url
              },
              blog {
                title
              }
            }
          }
        }
      }
    `;
    
    try {
      const response = await fetch('https://vaara-world.myshopify.com/api/2024-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ query }),
      });
      const data = await response.json();
      this.blogPosts = data.edges;
      this.paginationData = {
        nextUrl: data.pageInfo.hasNextPage,
        totalItems: data.edges.length,
      };
      this.renderBlogPosts();
    } catch (error) {
      console.error('Error fetching blog posts:', error);
    }
  }

  handleTagClick(tag) {
    if (this.selectedTags.includes(tag)) {
      this.selectedTags = this.selectedTags.filter((t) => t !== tag);
    } else {
      this.selectedTags = [...this.selectedTags, tag];
    }
    this.fetchBlogPosts();
  }

  renderBlogPosts() {
    const blogPostsContainer = document.createElement('div');
    blogPostsContainer.classList.add('blog-posts', `blog-posts--md-grid-cols-${this.columnSizeTablet}`, 'blog-posts--md-py-16', `blog-posts--lg-grid-cols-${this.columnSizeDesktop}`);

    this.blogPosts.forEach((post) => {
      const blogPostItem = document.createElement('div');
      blogPostItem.classList.add('blog-post', 'blog-post--relative');

      const img = document.createElement('img');
      img.src = post.image.url;
      img.alt = post.title;
      img.classList.add('blog-post__image');

      const title = document.createElement('h5');
      title.textContent = post.title;
      title.classList.add('blog-post__title');

      const excerpt = document.createElement('p');
      excerpt.textContent = post.excerptHtml;
      excerpt.classList.add('blog-post__excerpt');

      const link = document.createElement('a');
      link.href = `/blogs/${this.blogHandle}/${post.handle}`;
      link.textContent = 'View video';
      link.classList.add('blog-post__link');

      blogPostItem.appendChild(img);
      blogPostItem.appendChild(title);
      blogPostItem.appendChild(excerpt);
      blogPostItem.appendChild(link);
      blogPostsContainer.appendChild(blogPostItem);
    });

    this.shadowRoot.innerHTML = '';
    this.shadowRoot.appendChild(blogPostsContainer);

    if (this.paginationData.nextUrl) {
      const loadMoreButton = document.createElement('button');
      loadMoreButton.classList.add('blog-posts__load-more');
      loadMoreButton.textContent = 'Load More';
      loadMoreButton.addEventListener('click', () => this.fetchBlogPosts());
      const paginationContainer = document.createElement('div');
      paginationContainer.classList.add('blog-posts__pagination', 'blog-posts__pagination--pb-16', 'blog-posts__pagination--mt-5');
      paginationContainer.appendChild(loadMoreButton);
      this.shadowRoot.appendChild(paginationContainer);
    }

    this.shadowRoot.querySelectorAll('.filter').forEach((filter) => {
      filter.addEventListener('click', () => this.handleTagClick(filter.dataset.tag));
    });
  }
}

customElements.define('article-cards', ArticleCards);